// extracted by mini-css-extract-plugin
export default {"settingsPage":"Setting_settingsPage__e0ByI","settingsLayout":"Setting_settingsLayout__j6ZOw","settings":"Setting_settings__uPbBW","settingsSidebar":"Setting_settingsSidebar__fcSsY"};